// import React from "react";
// import SidebarGalleryPage from "../Main/Sidebargallery";
// import nss from "../../assets/Activities/NSS.jpg";

// export default function NssSection() {
//   const nssData = {
//     title: "NATIONAL SERVICE SCHEME",
//     intro: {
//       heading: "National Service Scheme",
//       description: `National Service Scheme (NSS) is an Indian government-sponsored public service program
//         conducted by the Ministry of Youth Affairs and Sports of the Government of India.
//         Aimed at developing student's personality through community service, NSS is a voluntary
//         association of young people in Colleges, Universities, and at +2 level working for a
//         campus-community linkage.`,
//       image: {
//         src: nss,
//         alt: "NSS Activity",
//         width: 250,
//         height: 150,
//       },
//     },
//     objectives: [
//       "Understand the community in which they work",
//       "Understand themselves in relation to their community",
//       "Identify the needs and problems of the community and involve them in problem-solving",
//       "Develop among themselves a sense of social and civic responsibility",
//       "Utilize their knowledge in finding practical solutions to individual and community problems",
//     ],
//   };

//   return (
//     <div className="container mx-auto bg-gray-100 p-10">
//       <div className="flex flex-col lg:flex-row gap-8">
//         {/* Main content */}
//         <div className="lg:w-2/3 rounded-lg  transition-shadow duration-300">
//           {/* <h1 className="text-3xl font-bold mb-4 text-white bg-teal-500 rounded-sm py-2 px-2">
//             {nssData.title}
//           </h1> */}
//           <div
//             className="overflow-hidden rounded-md  shadow-sm border-4 border-teal-500 transition-transform duration-300 hover:scale-105"
//             style={{ width: "100%" }}
//           >
//             <img
//               src={nssData.intro.image.src}
//               alt={nssData.intro.image.alt}
//               width={nssData.intro.image.width}
//               height={nssData.intro.image.height}
//               className="w-full h-auto p-2 rounded-lg"
//             />
//           </div>
//           <div className="border-4 border-teal-500 p-2 rounded-md mt-10">
//             <div className="bg-teal-500 text-white p-1 rounded-sm">
//               <h2 className="text-xl font-semibold ">
//                 {nssData.intro.heading}
//               </h2>
//             </div>
//             <p className="p-2 mt-2 text-gray-700 leading-relaxed text-justify">
//               {nssData.intro.description}
//             </p>
//             <h2 className="text-2xl font-semibold p-2 text-teal-600">
//               Objectives
//             </h2>
//             <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-2">
//               {nssData.objectives.map((objective, index) => (
//                 <li
//                   key={index}
//                   className="transition-colors duration-300 hover:text-teal-500 ml-2"
//                 >
//                   {objective}
//                 </li>
//               ))}
//             </ul>

//             <div>
//               <h2 className="text-2xl font-semibold p-2 text-teal-600">
//                 Programme officer
//               </h2>
//               <p className="list-disc pl-6 space-y-2 text-gray-700 mb-2">Smt. Pooja jaroliya</p>
//               <p className="list-disc pl-6 space-y-2 text-gray-700 mb-2">Email:poojajaroliya75@gmail.com </p>
//               <p className="list-disc pl-6 space-y-2 text-gray-700 mb-2">Mob:9926008892</p>
//             </div>
//           </div>
//         </div>

//         {/* Sidebar Gallery */}
//         <SidebarGalleryPage />
//       </div>
//     </div>
//   );
// }

import React from "react";
import SidebarGalleryPage from "../Main/Sidebargallery";
import nss from "../../assets/Activities/Nss1.jpg";
import nss2 from "../../assets/Activities/Nss2.jpg";
import nss3 from "../../assets/Activities/Nss3.jpg";
import nss4 from "../../assets/Activities/Nss4.jpg";
import nss5 from "../../assets/Activities/Nss5.jpg";

export default function NssSection() {
  // You can add your actual image imports in the nssImages array
  const nssImages = [
    {
      src: nss,
      alt: "NSS Activity 1",
    },
  
    {
      src: nss2,
      alt: "NSS Activity 2",
    },
    {
      src: nss3, 
      alt: "NSS Activity 3",
    },
    {
      src: nss4,
      alt: "NSS Activity 4",
    },
    {
      src: nss5,
      alt: "NSS Activity 4",
    },
  ];

  const nssData = {
    title: "NATIONAL SERVICE SCHEME",
    intro: {
      heading: "National Service Scheme",
      description: `National Service Scheme (NSS) is an Indian government-sponsored public service program
        conducted by the Ministry of Youth Affairs and Sports of the Government of India.
        Aimed at developing student's personality through community service, NSS is a voluntary
        association of young people in Colleges, Universities, and at +2 level working for a
        campus-community linkage.`,
    },
    objectives: [
      "Understand the community in which they work",
      "Understand themselves in relation to their community",
      "Identify the needs and problems of the community and involve them in problem-solving",
      "Develop among themselves a sense of social and civic responsibility",
      "Utilize their knowledge in finding practical solutions to individual and community problems",
    ],
  };

  return (
    <div className="container mx-auto bg-gray-100 p-10">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Main content */}
        <div className="lg:w-2/3 rounded-lg transition-shadow duration-300">
          {/* Image Gallery Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
            {nssImages.map((image, index) => (
              <div
                key={index}
                className="overflow-hidden rounded-md shadow-sm border-4 border-teal-500 transition-transform duration-300 hover:scale-105"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-64 object-cover p-2 rounded-lg"
                />
              </div>
            ))}
          </div>

          <div className="border-4 border-teal-500 p-2 rounded-md mt-4">
            <div className="bg-teal-500 text-white p-1 rounded-sm">
              <h2 className="text-xl font-semibold">{nssData.intro.heading}</h2>
            </div>
            <p className="p-2 mt-2 text-gray-700 leading-relaxed text-justify">
              {nssData.intro.description}
            </p>
            <h2 className="text-2xl font-semibold p-2 text-teal-600">
              Objectives
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-2">
              {nssData.objectives.map((objective, index) => (
                <li
                  key={index}
                  className="transition-colors duration-300 hover:text-teal-500 ml-2"
                >
                  {objective}
                </li>
              ))}
            </ul>

            <div>
              <h2 className="text-2xl font-semibold p-2 text-teal-600">
                Programme officer
              </h2>
              <p className="list-disc pl-6 space-y-2 text-gray-700 mb-2">
                Smt. Pooja jaroliya
              </p>
              <p className="list-disc pl-6 space-y-2 text-gray-700 mb-2">
                Email: poojajaroliya75@gmail.com
              </p>
              <p className="list-disc pl-6 space-y-2 text-gray-700 mb-2">
                Mob: 9926008892
              </p>
            </div>
          </div>
        </div>

        {/* Sidebar Gallery */}
        <SidebarGalleryPage />
      </div>
    </div>
  );
}